/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum PartFindingAnatomyRegionType {
  Head = 'Head',
  Cervical = 'Cervical',
  UpperExtremity = 'UpperExtremity',
  Thoracic = 'Thoracic',
  Lumbar = 'Lumbar',
  GeneralTorso = 'GeneralTorso',
  Sacral = 'Sacral',
  Pelvic = 'Pelvic',
  LowerExtremity = 'LowerExtremity'
}
